module.exports = __webpack_public_path__ + "images/emoji/loudspeaker.5962e89159d4c556f314.png";